<template>
    <form
        @change="sendDataForSaving"
    >
        <div class="row">
            <div class="col-lg-12">
                <div class="table-holder table-responsive ">
                    <table class="table shifts-table">
                        <thead>
                        <tr>
                            <th>Shift/Days</th>
                            <th>Mon</th>
                            <th>Tue</th>
                            <th>Wed</th>
                            <th>Thu</th>
                            <th>Fri</th>
                            <th>Sat</th>
                            <th>Sun</th>
                        </tr>
                        </thead>
                        <tbody>
                        <tr>
                            <td>Morning</td>
                            <td>
                                <div class="form-group form-group-1">
                                    <div class="form-check">
                                        <input
                                            class="form-check-input-checkbox"
                                            type="checkbox"
                                            name="morning"
                                            value="monday"
                                            id="mon-mor"
                                            v-model="form.morning">
                                        <label class="form-check-label" for="mon-mor"></label>
                                    </div>
                                </div>
                            </td>
                            <td>
                                <div class="form-group form-group-1">
                                    <div class="form-check">
                                        <input class="form-check-input-checkbox" type="checkbox"
                                               name="morning"
                                               value="tuesday"
                                               id="tue-mor"
                                               v-model="form.morning">
                                        <label class="form-check-label" for="tue-mor"></label>
                                    </div>
                                </div>
                            </td>
                            <td>
                                <div class="form-group form-group-1">
                                    <div class="form-check">
                                        <input class="form-check-input-checkbox" type="checkbox"
                                               name="morning"
                                               value="wednesday"
                                               id="wed-mor"
                                               v-model="form.morning">
                                        <label class="form-check-label" for="wed-mor"></label>
                                    </div>
                                </div>
                            </td>
                            <td>
                                <div class="form-group form-group-1">
                                    <div class="form-check">
                                        <input class="form-check-input-checkbox" type="checkbox"
                                               value="thursday"
                                               name="morning"
                                               id="thu-mor"
                                               v-model="form.morning">
                                        <label class="form-check-label" for="thu-mor"></label>
                                    </div>
                                </div>
                            </td>
                            <td>
                                <div class="form-group form-group-1">
                                    <div class="form-check">
                                        <input class="form-check-input-checkbox" type="checkbox"
                                               value="friday"
                                               name="morning"
                                               id="fri-mor"
                                               v-model="form.morning">
                                        <label class="form-check-label" for="fri-mor"></label>
                                    </div>
                                </div>
                            </td>
                            <td>
                                <div class="form-group form-group-1">
                                    <div class="form-check">
                                        <input class="form-check-input-checkbox" type="checkbox"
                                               value="saturday"
                                               name="morning"
                                               id="sat-mor"
                                               v-model="form.morning">
                                        <label class="form-check-label" for="sat-mor"></label>
                                    </div>
                                </div>
                            </td>
                            <td>
                                <div class="form-group form-group-1">
                                    <div class="form-check">
                                        <input class="form-check-input-checkbox" type="checkbox"
                                               value="sunday"
                                               name="morning"
                                               id="sun-mor"
                                               v-model="form.morning">
                                        <label class="form-check-label" for="sun-mor"></label>
                                    </div>
                                </div>
                            </td>
                        </tr>
                        <tr>
                            <td>Afternoon</td>
                            <td>
                                <div class="form-group form-group-1">
                                    <div class="form-check">
                                        <input class="form-check-input-checkbox" type="checkbox"
                                               value="monday"
                                               name="afternoon"
                                               id="aft-mon"
                                               v-model="form.afternoon">
                                        <label class="form-check-label" for="aft-mon"></label>
                                    </div>
                                </div>
                            </td>
                            <td>
                                <div class="form-group form-group-1">
                                    <div class="form-check">
                                        <input class="form-check-input-checkbox" type="checkbox"
                                               value="tuesday"
                                               name="afternoon"
                                               id="aft-tue"
                                               v-model="form.afternoon">
                                        <label class="form-check-label" for="aft-tue"></label>
                                    </div>
                                </div>
                            </td>
                            <td>
                                <div class="form-group form-group-1">
                                    <div class="form-check">
                                        <input class="form-check-input-checkbox" type="checkbox"
                                               value="wednesday"
                                               name="afternoon"
                                               id="aft-wed"
                                               v-model="form.afternoon">
                                        <label class="form-check-label" for="aft-wed"></label>
                                    </div>
                                </div>
                            </td>
                            <td>
                                <div class="form-group form-group-1">
                                    <div class="form-check">
                                        <input class="form-check-input-checkbox" type="checkbox"
                                               value="thursday"
                                               name="afternoon"
                                               id="aft-thu"
                                               v-model="form.afternoon">
                                        <label class="form-check-label" for="aft-thu"></label>
                                    </div>
                                </div>
                            </td>
                            <td>
                                <div class="form-group form-group-1">
                                    <div class="form-check">
                                        <input class="form-check-input-checkbox" type="checkbox"
                                               value="friday"
                                               name="afternoon"
                                               id="aft-fri"
                                               v-model="form.afternoon">
                                        <label class="form-check-label" for="aft-fri"></label>
                                    </div>
                                </div>
                            </td>
                            <td>
                                <div class="form-group form-group-1">
                                    <div class="form-check">
                                        <input class="form-check-input-checkbox" type="checkbox"
                                               value="saturday"
                                               name="afternoon"
                                               id="aft-sat"
                                               v-model="form.afternoon">
                                        <label class="form-check-label" for="aft-sat"></label>
                                    </div>
                                </div>
                            </td>
                            <td>
                                <div class="form-group form-group-1">
                                    <div class="form-check">
                                        <input class="form-check-input-checkbox" type="checkbox"
                                               value="sunday"
                                               name="afternoon"
                                               id="aft-sun"
                                               v-model="form.afternoon">
                                        <label class="form-check-label" for="aft-sun"></label>
                                    </div>
                                </div>
                            </td>
                        </tr>
                        <tr>
                            <td>Night</td>
                            <td>
                                <div class="form-group form-group-1">
                                    <div class="form-check">
                                        <input class="form-check-input-checkbox" type="checkbox"
                                               value="monday"
                                               name="night"
                                               id="night-mon"
                                               v-model="form.night">
                                        <label class="form-check-label" for="night-mon"></label>
                                    </div>
                                </div>
                            </td>
                            <td>
                                <div class="form-group form-group-1">
                                    <div class="form-check">
                                        <input class="form-check-input-checkbox" type="checkbox"
                                               value="tuesday"
                                               name="night"
                                               id="night-tue"
                                               v-model="form.night">
                                        <label class="form-check-label" for="night-tue"></label>
                                    </div>
                                </div>
                            </td>
                            <td>
                                <div class="form-group form-group-1">
                                    <div class="form-check">
                                        <input class="form-check-input-checkbox" type="checkbox"
                                               value="wednesday"
                                               name="night"
                                               id="night-wed"
                                               v-model="form.night">
                                        <label class="form-check-label" for="night-wed"></label>
                                    </div>
                                </div>
                            </td>
                            <td>
                                <div class="form-group form-group-1">
                                    <div class="form-check">
                                        <input class="form-check-input-checkbox" type="checkbox"
                                               value="thursday"
                                               name="night"
                                               id="night-thu"
                                               v-model="form.night">
                                        <label class="form-check-label" for="night-thu"></label>
                                    </div>
                                </div>
                            </td>
                            <td>
                                <div class="form-group form-group-1">
                                    <div class="form-check">
                                        <input class="form-check-input-checkbox" type="checkbox"
                                               value="friday"
                                               name="night"
                                               id="night-fri"
                                               v-model="form.night">
                                        <label class="form-check-label" for="night-fri"></label>
                                    </div>
                                </div>
                            </td>
                            <td>
                                <div class="form-group form-group-1">
                                    <div class="form-check">
                                        <input class="form-check-input-checkbox" type="checkbox"
                                               value="saturday"
                                               name="night"
                                               id="night-sat"
                                               v-model="form.night">
                                        <label class="form-check-label" for="night-sat"></label>
                                    </div>
                                </div>
                            </td>
                            <td>
                                <div class="form-group form-group-1">
                                    <div class="form-check">
                                        <input class="form-check-input-checkbox" type="checkbox"
                                               value="sunday"
                                               name="night"
                                               id="night-sun"
                                               v-model="form.night">
                                        <label class="form-check-label" for="night-sun"></label>
                                    </div>
                                </div>
                            </td>
                        </tr>
                        </tbody>
                    </table>
<!--                    <p v-if="shouldShowMessage" style="font-size: 12px; color: red">* select at least one field </p>-->
                </div>
            </div>
        </div>

        <ValidationProvider
            name="Time absence"
            rules="latinAndNumbers|min:2|max:500"
            v-slot="{errors}"
            class="row"
        >
            <div class="col-md-12">
                <div class="form-group form-group-1">
                    <label for="" class="form-label">
                        Please indicate if you have any times you are NOT able to work
                        and why (other jobs, religious obligations, etc.)
                    </label>
                    <div class="form-group form-group-1">
                        <input type="text" class="form-control" v-model="form.time_absence">
                        <FormError :error="errors[0]" name="Time absence"></FormError>
                    </div>
                </div>
            </div>
        </ValidationProvider>

    </form>
</template>

<script>
export default {
    name: 'AvailabilityForm',
    emits: ['data-changed'],
    props: {
        user: {
            type: Object
        }
    },
    data() {
        return {
            form: {
                time_absence: '',
                morning: [],
                afternoon: [],
                night: [],
            },
        }
    },

    methods: {
        sendDataForSaving() {
            this.$emit('data-changed', this.form);
        },
    },
    mounted() {
        if (this.user.availability !== null) {
            this.form.time_absence = this.user.availability.time_absence ?? '';
            this.form.morning = this.user.availability.morning ?? [];
            this.form.night =  this.user.availability.night ?? [];
            this.form.afternoon =  this.user.availability.afternoon ?? [];
        }
    },
    computed: {
        shouldShowMessage() {
            return (
                this.form.morning.length === 0 &&
                this.form.afternoon.length === 0 &&
                this.form.night.length === 0
            );
        }
    }
}

</script>

<style scoped>

</style>
